import { ServerClient } from '../../utils/http/http-clients';
import { IResponseList } from '../../models/response-list.interface';
import { ITrafficRead } from './traffic-service.types';
import { IParamsLimit } from 'common/models/params-limit.interface';

class TrafficService {
  async getTraffic(
    pageLimit: IParamsLimit | null | undefined,
    filter: string | null | undefined,
    sort: string | null | undefined,
    search: string | null | undefined = '',
    isArchive: boolean = false,
  ): Promise<IResponseList<ITrafficRead>> {
    const path = isArchive ? '/traffic-logs/archive' : '/traffic-logs';

    const res = await ServerClient.get<IResponseList<ITrafficRead>>(path, {
      params: {
        filter,
        ...pageLimit,
        sort,
        search,
        isArchive,
      },
    });
    return res?.data;
  }
}

export const trafficService = new TrafficService();
export default trafficService;
